module.exports = __webpack_public_path__ + "static/HR Portal Meine Daten Dossier-e4e3f27c41615e7f0af31779547f14df.jpg";